import Icons from '@datacloud-incubation/frontend-icons-module';
import {
  autoUpdate,
  flip,
  offset,
  shift,
  useClick,
  useDismiss,
  useFloating,
  useInteractions
} from '@floating-ui/react';
import classNames from 'classnames';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { useLocation, useNavigate } from 'react-router';
import SettingsItem from '@components/Settings/components/SettingsItem';
import { getSettingsMenu } from '@components/Settings/constants/settings.constant';
import { ROUTER_PATH } from '@constants/routerItems.constant';
import type { TSettingsMenuItem } from '@components/Settings/models/settings.model';
import styles from './Settings.module.css';

const Settings = () => {
  const [showMenu, setShowMenu] = useState(false);
  const portalRoot = document.getElementById('root');
  const navigate = useNavigate();

  const { pathname } = useLocation();
  const activeUrls: string[] = [ROUTER_PATH.viewProfile, ROUTER_PATH.editProfile];

  const { refs, context, floatingStyles } = useFloating({
    open: showMenu,
    onOpenChange: setShowMenu,
    placement: 'bottom-start',
    middleware: [offset({ mainAxis: 4, alignmentAxis: 0 }), flip(), shift()],
    whileElementsMounted: autoUpdate
  });

  const click = useClick(context);
  const dismiss = useDismiss(context);
  const { getReferenceProps, getFloatingProps } = useInteractions([click, dismiss]);

  const settingMenuMapping = ({ label, Icon, onClick }: TSettingsMenuItem) => (
    <SettingsItem
      key={label}
      label={label}
      onClick={() => {
        onClick();
        setShowMenu(false);
      }}
      Icon={Icon}
    />
  );

  return (
    <>
      <button
        aria-label='Settings'
        className={classNames(styles.icon, {
          active: activeUrls.includes(pathname)
        })}
        ref={refs.setReference}
        {...getReferenceProps()}
      >
        <Icons.IconSettings />
      </button>

      {showMenu &&
        portalRoot &&
        createPortal(
          <ul
            ref={refs.setFloating}
            style={floatingStyles}
            className={styles.list}
            {...getFloatingProps()}
          >
            {getSettingsMenu(navigate).map(settingMenuMapping)}
          </ul>,
          portalRoot
        )}
    </>
  );
};

export default Settings;
